import styled from "styled-components";
import theme from "../../theme/theme";

const SongStyle = styled.div`
  border-radius: 10px;
  border: 2px solid black;
  padding: 30px;
  margin: 30px 20px;

  .song-container__songtitle,
  .song-collection__song {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .song-detail__songtitle,
  .song-detail__song {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .song-icon__container {
    margin: 0;
    padding: 0;
    background-color: ${theme.blueDark};
    display: flex;
    width: 90px;
    height: 90px;
    margin: 0;
    padding: 0;
    justify-content: center;
    border-radius: 50px;
    align-items: center;
    position: absolute;
    right: 0;
    top: -60px;
  }

  .song-container {
    width: inherit;
    margin: 0;
    display: flex;
    flex-direction: column;
  }

  .songDetail-header {
    display: flex;
    justify-content: center;
  }

  li.song-detail__document {
    display: flex;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
  }

  .song-collection__button {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 10px;
    gap: 10px;
  }

  .song-container__name {
    font-size: 2em;
    margin: 0;
    color: #583e3b;
    font-weight: 800;
    margin: 0;
    width: 70%;
  }
  .song {
    margin-bottom: 20px;
  }

  .song-container__button {
    margin-top: 10px;
  }

  .secondary {
    font-family: Caveat brush;
    width: 100%;
    height: 45px;
    border-radius: 10px;
    font-size: 1.25em;
    font-weight: bold;
    color: red;
    border: 3px solid red;
  }

  p {
    padding-top: 5px;
    padding-bottom: 5px;
    margin-top: 0;
    margin-bottom: 0;
  }
  .song-details__button {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 10px;
    margin-top: 10px;
    gap: 10px;
  }
  .label {
    font-size: 1rem;
    font-weight: 800;
    padding-right: 15px;
  }
  iframe {
    border-radius: 15px;
    margin-top: 20px;
  }
`;

export default SongStyle;
